module.exports = __webpack_public_path__ + "media/images/header22-fe7a97da5349319ed4fb5595f0fcb171.png";